import React from 'react';
import { Settings as SettingsIcon, Moon, Sun, MessageCircle, ExternalLink } from 'lucide-react';
import { Card } from '../../components/common';
import useTheme from '../../hooks/useTheme';

const SUPPORT_WHATSAPP = 'https://wa.me/5598981420180';

const Settings = () => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-2.5 font-display">
          <div className="w-8 h-8 bg-slate-100 dark:bg-slate-800 rounded-lg flex items-center justify-center">
            <SettingsIcon className="w-4 h-4 text-slate-600 dark:text-slate-400" />
          </div>
          Configurações
        </h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5 ml-10">
          Personalize sua experiência na plataforma
        </p>
      </div>

      <Card>
        <Card.Header>
          <Card.Title>Aparência</Card.Title>
          <Card.Description>Ajuste o tema visual da plataforma</Card.Description>
        </Card.Header>
        <Card.Body>
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                isDark
                  ? 'bg-slate-700 dark:bg-slate-700'
                  : 'bg-amber-50'
              }`}>
                {isDark
                  ? <Moon className="w-5 h-5 text-primary-400" />
                  : <Sun  className="w-5 h-5 text-amber-500" />
                }
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">
                  Modo {isDark ? 'Escuro' : 'Claro'}
                </p>
                <p className="text-xs text-slate-400 dark:text-slate-500">
                  {isDark ? 'Tema escuro ativado' : 'Tema claro ativado'}
                </p>
              </div>
            </div>

            <button
              onClick={toggleTheme}
              className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 dark:focus:ring-offset-slate-900 flex-shrink-0 ${
                isDark ? 'bg-primary-500' : 'bg-slate-200'
              }`}
              aria-label="Alternar tema"
            >
              <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                isDark ? 'translate-x-6' : 'translate-x-1'
              }`} />
            </button>
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <Card.Title>Suporte</Card.Title>
          <Card.Description>Precisa de ajuda? Fale com nossa equipe</Card.Description>
        </Card.Header>
        <Card.Body>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">WhatsApp</p>
                <p className="text-xs text-slate-400 dark:text-slate-500">Atendimento rápido via WhatsApp</p>
              </div>
            </div>
            <a
              href={SUPPORT_WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-sm font-semibold transition-colors shadow-sm flex-shrink-0"
            >
              <MessageCircle className="w-4 h-4" />
              Falar com Suporte
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Settings;
